import type { DSPageContentProps } from "../types/props";

export const DS_PAGE_CLASSES = {
  Root: "ds-page",
} as const;

export const DS_PAGE_COLUMNS_CLASSES = {
  Root: "ds-page-columns",
  Column: "ds-page-columns__column",
  ResizeHandle: "ds-page-columns__resize-handle",
} as const;

export const DS_PAGE_HEADER_CLASSES = {
  Root: "ds-page-header",
  Title: "ds-page-header__title",
  Actions: "ds-page-header__actions",
} as const;

export const DS_PAGE_CONTENT_CLASSES = {
  Root: "ds-page-content",
} as const;

export const DS_PAGE_CONTENT_PADDING_CLASSES: Record<NonNullable<DSPageContentProps["padding"]>, string> = {
  sm: "ds-page-content--padding-sm",
  md: "ds-page-content--padding-md",
  lg: "ds-page-content--padding-lg",
};
